import React, { useState } from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";
import { Eye, EyeOff } from "lucide-react";

// Campo de contraseña con botón para mostrarla u ocultarla.
const PasswordInput = ({ id, className, ...rest }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`hl-password ${className || ""}`}>
      <Input id={id} type={visible ? "text" : "password"} {...rest} />
      <button
        type="button"
        className="hl-password__toggle"
        onClick={() => setVisible((value) => !value)}
        aria-label={visible ? "Ocultar contraseña" : "Mostrar contraseña"}
        aria-pressed={visible}
        aria-controls={id}
      >
        {visible ? (
          <EyeOff size={16} strokeWidth={1.75} aria-hidden="true" />
        ) : (
          <Eye size={16} strokeWidth={1.75} aria-hidden="true" />
        )}
      </button>
    </div>
  );
};

PasswordInput.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
};

export default PasswordInput;
